import React from 'react';
import classnames from 'classnames';

import {Anchor, Heading, ListGroup, ListGroupItem, StatusText, Text} from '@albert-io/atomic';

import {AuthorDashboardConsumer} from '../AuthorDashboardProvider/AuthorDashboardConsumer.react';
import './author-dashboard-recent.scss';

const makeQuestionsCard = (recentQuestions) => {
  return recentQuestions.map((question, idx) => {
    const currQuestion = question.get('question');
    const questionSet = question.get('questionSet');
    const title = currQuestion.getTitle();
    const status = questionSet.getStatus();
    const subject = questionSet.getAuthoringSubject().getName();
    const questionURL = `queue/${questionSet.getId()}/${currQuestion.getId()}`;
    const statusClassnames = classnames('author-dashboard-recent__status', {
      'author-dashboard-recent__status--draft': status === 'draft',
      'author-dashboard-recent__status--pending': status === 'pending',
      'author-dashboard-recent__status--rejected': status === 'rejected',
      'author-dashboard-recent__status--published': status === 'published'
    });

    return (
      <ListGroupItem key={idx} className='author-dashboard-recent__question-container'>
        <div className='author-dashboard-recent__question-info-container'>
          <Anchor href={questionURL} target='_blank' className='author-dashboard-recent__title'>
            <div>{title}</div>
          </Anchor>
          <Text className='author-dashboard-recent__subject'>{subject}</Text>
        </div>
        <StatusText className={statusClassnames}>{status}</StatusText>
      </ListGroupItem>
    );
  });
};

const AuthorDashboardRecent = () => {
  return (
    <AuthorDashboardConsumer field='recentQuestions'>
      {({noRecent, recentQuestions}) => {
        return (
          <div>
            <Heading size='m' className='author-dashboard-recent__header u-mar-b_3'>
              Recent
            </Heading>
            {noRecent && <Text>You have no recent questions</Text>}
            {!noRecent && (
              <ListGroup className='author-dashboard-recent__container'>
                {makeQuestionsCard(recentQuestions)}
              </ListGroup>
            )}
          </div>
        );
      }}
    </AuthorDashboardConsumer>
  );
};

export default AuthorDashboardRecent;
